.dashletHeaderWithTitleWithFilter {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.dashletHeaderWithoutTitleWithFilter {
    display: flex;
    justify-content: flex-end;
}

.modalRow {
    display: flex;
}

.modalRowSeparator {
    margin-left: 10px;
}

.riskCalloutsContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: space-between;
    margin-top: 10px;
}

.riskCallout {
    width: 250px;
}

.riskCalloutTitle {
    display: flex;
}